import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const SpecialFocus = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.specialFocus.title')}
      contentType="specialFocus30"
      description={t('page.specialFocus.desc')}
      outputLabel={t('page.specialFocus.output')}
    />
  );
};
